import { render, staticRenderFns } from "./dispatch_rule_detail.vue?vue&type=template&id=7a41503c&scoped=true"
import script from "./dispatch_rule_detail.vue?vue&type=script&lang=js"
export * from "./dispatch_rule_detail.vue?vue&type=script&lang=js"
import style0 from "./dispatch_rule_detail.vue?vue&type=style&index=0&id=7a41503c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a41503c",
  null
  
)

export default component.exports